import SDK from "../../config";
import axios from "axios";
import toast from "react-hot-toast";
import postVisitorsData from "../web/visitors";

/**
 * Handles the actions to be taken upon successful payment.
 * @param {Object} paymentIntent - The payment intent object from the payment provider.
 * @param {string} methodType - The type of payment method used.
 * @param {string} cardName - The name on the card.
 * @param {string} email - The email address of the customer.
 * @param {string} phone - The phone number of the customer.
 * @param {string} zipcode - The zipcode of the customer.
 */
const handlePaymentSuccess = async (
  paymentIntent,
  methodType,
  cardName,
  email,
  // phone,
  // zipcode,
  paymentWay
) => {
  const tagsString = "IOS,RESERVED";
  const type = "gift";
  const queryParams = new URLSearchParams({
    email_address: email,
    status: "subscribed",
    tags: tagsString,
    first_name: cardName,
    // phone_number: phone,
    AddToCart: "1",
    reserved: "1",
    type,
  });

  try {
    // Track purchase event using Facebook Pixel if available
    if (window.fbq) {
      window.fbq("track", "Purchase", {
        value: SDK.FB_PRICE,
        currency: SDK.FB_CURRNECY,
      });
    }

    // Track complete payment event using TikTok Pixel if available
    if (window.ttq) {
      window.ttq.track("CompletePayment");
    }

    // Save the payment intent details to the server
    const paymentIntentResponse = await fetch(
      `${SDK.BASE_URL}/api/save-payment-intent`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          // phone_number: phone,
          // zipcode,
          amount: paymentIntent.amount,
          paymentIntentId: paymentIntent.id,
          clientSecret: paymentIntent.client_secret,
          created: new Date(paymentIntent.created * 1000),
          currency: paymentIntent.currency,
          status: paymentIntent.status,
          paymentMethod: paymentIntent.payment_method,
          method_type: methodType,
          paymentWay,
          first_name: "",
          android: false,
          tagsString,
          type,
        }),
      }
    );

    const queryString = queryParams.toString();
    await axios.post(`${SDK.BASE_URL}/api/post_email_smashsend?${queryString}`);
    const lead = true;
    const addtocart = true;
    const purchase = true;
    const amount = SDK.FB_PRICE;
    postVisitorsData({
      email,
      lead,
      addtocart,
      purchase,
      amount,
      tags: tagsString,
    });

    // Check if saving payment intent was successful
    if (!paymentIntentResponse.ok) {
      const errorData = await paymentIntentResponse.json();
      console.error("Error saving payment intent:", errorData.error);
      toast.error("Failed to save payment details.");
      return;
    }
  } catch (error) {
    console.error("Error processing payment success:", error);
    toast.error("Please try again.");
  }
};

export default handlePaymentSuccess;
